<script setup lang="ts">
import $ from 'jquery';

import { onMounted, ref } from 'vue';
import { useFilters } from '.';

import { date, euro } from '@/helpers';

import 'slick-carousel';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

const { getFeatured, featured } = useFilters();

const { location } = window;

const featuredSliderElement = ref<HTMLDivElement | null>(null);

function prevSlide() {
  if (!featuredSliderElement.value) return;
  $(featuredSliderElement.value)?.slick('slickPrev');
}

function nextSlide() {
  if (!featuredSliderElement.value) return;
  $(featuredSliderElement.value)?.slick('slickNext');
}

onMounted(async () => {
  await getFeatured();

  if (!featuredSliderElement.value) return;

  $(featuredSliderElement.value)?.slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    rows: 0,
    arrows: true,
    infinite: false,
    prevArrow: $('.slider.featured .prev'),
    nextArrow: $('.slider.featured .next'),
    responsive: [
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 1.2,
        },
      },
    ],
  });
});
</script>

<template>
  <template v-if="featured">
    <section class="section alt">
      <div class="container">
        <div class="section__content">
          <h2 class="section__title center">UITGELICHTE DEALS</h2>
        </div>
        <div class="slider slider--featured" ref="featuredSliderElement">
          <template v-for="(feature, index) in featured" :key="index">
            <div class="slider-items">
              <a :href="feature.pricing.accommodationurl" class="block block--featured">
                <p class="block__img__meta">{{ date.format(new Date(feature.date)) }}</p>
                <img :src="feature.room.accommodation.photos[0].url" alt="" class="block__img" />
                <div class="block__content">
                  <h4 class="block__title">{{ feature.room.accommodation.name }}</h4>
                  <p class="block__meta">{{ feature.duration }} nachten • {{ feature.pricing.persons.adults }} personen</p>
                  <span class="button" @click="location.href = feature.pricing.accommodationurl">
                    vanaf <span>{{ euro.format(feature.pricing.price.perperson.amount) }} p.p.</span>
                  </span>
                </div>
              </a>
            </div>
          </template>
        </div>
        <div class="slider featured">
          <ul class="slider__arrows">
            <li>
              <a href="#" class="prev" @click="prevSlide">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                  <path
                    fill="#FFF"
                    d="M10 0c5.523 0 10 4.477 10 10s-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0Zm0 2a8 8 0 0 0-8 8 8 8 0 0 0 8 8 8 8 0 0 0 8-8 8 8 0 0 0-8-8Zm-.293 4.293a1 1 0 0 1 0 1.414L8.415 9H14a1 1 0 0 1 0 2H8.415l1.292 1.293a1 1 0 0 1 .083 1.32l-.083.094a1 1 0 0 1-1.414 0l-3-3-.073-.082a1.005 1.005 0 0 1-.007-.008l.08.09A1.008 1.008 0 0 1 5 10.02v-.037c0-.024.002-.048.004-.071L5 10a1.008 1.008 0 0 1 .213-.617.97.97 0 0 1 .08-.09l3-3a1 1 0 0 1 1.414 0Z"
                  />
                </svg>
              </a>
            </li>
            <li>
              <a href="#" class="next" @click="nextSlide">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                  <path
                    fill="#FFF"
                    d="M10 0c5.523 0 10 4.477 10 10s-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0Zm0 2a8 8 0 0 0-8 8 8 8 0 0 0 8 8 8 8 0 0 0 8-8 8 8 0 0 0-8-8Zm1.707 4.293 3 3a.97.97 0 0 1 .08.09l-.08-.09a1.008 1.008 0 0 1 .292.675L15 10v.033l-.004.052L15 10a1.008 1.008 0 0 1-.213.617l-.007.008-.073.082-3 3a1 1 0 0 1-1.414-1.414L11.585 11H6a1 1 0 0 1 0-2h5.585l-1.292-1.293a1 1 0 0 1-.083-1.32l.083-.094a1 1 0 0 1 1.414 0Z"
                  />
                </svg>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </section>
  </template>
</template>
